module.exports = __webpack_public_path__ + "img/home_load_item-v2.85ee9c6d.svg";